import { render, staticRenderFns } from "./VKanbanBoard.vue?vue&type=template&id=e53b4bbe"
import script from "./VKanbanBoard.vue?vue&type=script&lang=js"
export * from "./VKanbanBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports